// Subtle endless marquee ticker used across pages (mantras / brand line)
export default function MantraTicker({
  items = [
    "Quality Relationship",
    "Quality Service",
    "Quality Life",
    "Est. 1993",
    "Osaka Group",
  ],
}) {
  const list = [...items, ...items, ...items, ...items];
  return (
    <div
      data-testid="mantra-ticker"
      className="overflow-hidden border-y border-[var(--gold-line-soft)] py-6 bg-white"
    >
      <div className="ticker-track gap-14 whitespace-nowrap">
        {list.map((m, i) => (
          <span key={i} className="inline-flex items-center gap-14">
            <span className="font-couture-italic text-3xl lg:text-4xl text-[var(--ink)]">
              {m}
            </span>
            <span className="text-[var(--gold)] text-base" aria-hidden="true">
              ✦
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
